import {useEffect} from 'react';

import {hasSpecialCharacter, hasNumber, validatePassword} from '@src/utils/validations';
import {useBoolean} from '@src/hooks/useBoolean';

const PASSWORD_MINIMUM_ACCEPTED_CHARACTERS = 8;

export const useRulesForPassword = (password: string) => {
  const [isValidPassword, setIsValidPassword] = useBoolean(false);

  const passwordHasEnoughCharacters = password.length >= PASSWORD_MINIMUM_ACCEPTED_CHARACTERS;
  const passwordHasSpecialCharacter = hasSpecialCharacter(password);
  const passwordHasNumber = hasNumber(password);

  useEffect(() => {
    const {isValid} = validatePassword(password);
    setIsValidPassword.setValue(!!isValid);
  }, [password, setIsValidPassword]);

  return {passwordHasEnoughCharacters, passwordHasSpecialCharacter, passwordHasNumber, isValidPassword};
};
